/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateSectionsControllerFindOneQueryResponse, TemplateSectionsControllerFindOnePathParams, TemplateSectionsControllerFindOneQueryParams, TemplateSectionsControllerFindOne400, TemplateSectionsControllerFindOne401, TemplateSectionsControllerFindOne403, TemplateSectionsControllerFindOne404 } from "../../models/checklistsController/TemplateSectionsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templateSectionsControllerFindOne } from "../../clients/checklistsService/templateSectionsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templateSectionsControllerFindOneQueryKey = (id: TemplateSectionsControllerFindOnePathParams["id"], params: TemplateSectionsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/checklist-template-sections/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type TemplateSectionsControllerFindOneQueryKey = ReturnType<typeof templateSectionsControllerFindOneQueryKey>;
export function templateSectionsControllerFindOneQueryOptions(id: TemplateSectionsControllerFindOnePathParams["id"], params?: TemplateSectionsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templateSectionsControllerFindOneQueryKey(id, params);
  return queryOptions<TemplateSectionsControllerFindOneQueryResponse, ResponseErrorConfig<TemplateSectionsControllerFindOne400 | TemplateSectionsControllerFindOne401 | TemplateSectionsControllerFindOne403 | TemplateSectionsControllerFindOne404>, TemplateSectionsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templateSectionsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a specific checklist template section by ID
 * {@link /api/v1/checklist-template-sections/:id}
 */
export function useTemplateSectionsControllerFindOne<TData = TemplateSectionsControllerFindOneQueryResponse, TQueryData = TemplateSectionsControllerFindOneQueryResponse, TQueryKey extends QueryKey = TemplateSectionsControllerFindOneQueryKey>(id: TemplateSectionsControllerFindOnePathParams["id"], params?: TemplateSectionsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<TemplateSectionsControllerFindOneQueryResponse, ResponseErrorConfig<TemplateSectionsControllerFindOne400 | TemplateSectionsControllerFindOne401 | TemplateSectionsControllerFindOne403 | TemplateSectionsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templateSectionsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...templateSectionsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TemplateSectionsControllerFindOne400 | TemplateSectionsControllerFindOne401 | TemplateSectionsControllerFindOne403 | TemplateSectionsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}